import React, { useState, useEffect, useRef, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Navbar, Container } from 'react-bootstrap'
import GlobalContext from '../../Context/Context'
import { useLanguage } from '../../Context/LanguageContext'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'

// Import Assets
import logoLight from '../../Assets/img/imigo-logo.png'
import logoDark from '../../Assets/img/imigo-logo.png'

const HeaderImigo = (props) => {
  const { topSpace } = props;
  const { setHeaderHeight } = useContext(GlobalContext);
  const { t, getLocalizedPath } = useLanguage();
  const headerRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    const measure = () => {
      const el = headerRef.current
      if (el) setHeaderHeight(el.offsetHeight)
    }
    const t = setTimeout(measure, 500)
    const onResize = () => setTimeout(measure, 500)
    window.addEventListener('resize', onResize)
    return () => {
      clearTimeout(t)
      window.removeEventListener('resize', onResize)
    }
  }, [setHeaderHeight])

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 100) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  return (
    <header
      className={`header-imigo ${topSpace ? "top-space" : ""} ${
        scrolled ? "sticky-header" : ""
      }`}
      ref={headerRef}
    >
      <Navbar expand="xl" className="imigo-navbar py-0 px-0 min-h-[64px] xl:min-h-[80px]">
        <Container fluid className="imigo-navbar-container px-3 px-xl-4">
          <Link
            aria-label="header logo"
            className="navbar-brand d-flex align-items-center py-2 me-2 me-xl-3 flex-shrink-0"
            to={getLocalizedPath('/')}
          >
            <img
              className="imigo-navbar-logo"
              src={scrolled ? logoDark : logoLight}
              alt="Imigo Logo"
            />
          </Link>
          <Navbar.Toggle
            aria-controls="navbarNav"
            className="imigo-navbar-toggler border-0 shadow-none"
          />
          <Navbar.Collapse id="navbarNav" className="imigo-navbar-collapse">
            <ul className="navbar-nav imigo-nav-menu mx-xl-auto my-3 my-xl-0">
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/')}>
                  {t('menu.home')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/articles')}>
                  {t('menu.articles')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/businesses')}>
                  {t('menu.businesses')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/events')}>
                  {t('menu.events')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/marketplace')}>
                  {t('menu.marketplace')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/forum')}>
                  {t('menu.forum')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/activities')}>
                  {t('menu.activities')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/about')}>
                  {t('menu.about')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link imigo-nav-link" to={getLocalizedPath('/contact')}>
                  {t('menu.contact')}
                </Link>
              </li>
            </ul>
            <div className="imigo-navbar-actions d-flex flex-column flex-sm-row flex-wrap align-items-stretch align-items-sm-center justify-content-center justify-content-xl-end gap-2 pb-3 pb-xl-0">
              <LanguageSwitcher />
              <a
                href="https://apps.apple.com/us/app/imigo-connect/id6744267446"
                className="btn btn-sm btn-primary text-nowrap px-3"
              >
                {t('common.iosApp')}
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=app.imigo"
                className="btn btn-sm btn-primary text-nowrap px-3"
              >
                {t('common.androidApp')}
              </a>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  )
}

export default HeaderImigo 